import Vue from 'vue';
import axios from 'axios';

Vue.use(axios);

Vue.prototype.$URL = 'http://1.15.101.200:8082/';// 'http://114.219.56.82:8082/';// 'https://tstxg.ruolin-link.com/';'http://192.168.1.53:8082/'//
var service = axios.create({
    baseURL: Vue.prototype.$URL
});
// timeout: 5000

service.interceptors.request.use(
    config => {
        config.headers.xgToken = localStorage.getItem('TOKEN');
        config.headers['Access-Control-Allow-Origin'] = '*';
        return config;
    },
    error => Promise.reject(error)
);

service.interceptors.response.use(res => {
    // eslint-disable-next-line
    console.log(res);
    // token失效
    if (res.config.url.indexOf('user/login') == -1 && (res.status == 401 || res.data.code == 401)) {
        localStorage.setItem('TOKEN', '');
        location.reload();
    }
    return res;
}, res2 => {
    // eslint-disable-next-line
    console.log(res2);
    if (res2.config.url.indexOf('user/login') == -1 && res2.response && (res2.response.status == 401 || res2.response.data.code == 401)) {
        localStorage.setItem('TOKEN', '');
        location.reload();
    }
    return res2.response || res2;
  }
);

export default service;